// extracted by mini-css-extract-plugin
export var splash = "Splash-module--splash--4xXOj";
export var splashText = "Splash-module--splashText--Kiz5G";
export var title = "Splash-module--title--NTeCR";